import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // this.$store.state.nowImei
    // 是否是开发状态
    isDev: true,
    // 公众号的名称
    customerName: '',
    // 公众号标识
    customer: '',
    // 当前设备号
    nowImei: '',
    // 当前ICCID
    nowIccid: '',
    // 用户openid
    openid: '',
    // 微信信息(头像昵称等)
    wxInfo: null,
    // 测试设备号
    // debugImei: '868607030181280',
    // 分页 单页列表数量
    onePageNumber: 18,
    onePageNumberLong: 30,
    // 特殊的超时时间,默认是15000
    timeoutLongTime: 30000,
    // token
    token: '',
    // 设备能力
    // 是否已经请求到数据(用于判断是否请求)
    devSet: false,
    // 摄像头列表
    devCameraList: [
      { name: '前置摄像头', value: 1 },
      { name: '后置摄像头', value: 2 },
      // { name: '前+后摄像头', value: 3 }
    ],
    // 导航能力(保存在cookies)
    // 首页的banner
    indexBanner: [],
    // 首页菜单
    menuList: [],
    // 是否切换了设备(用于首页和设备切换页面)
    isChangeDev: false,
     // 是否设备被抢绑了
    isChangeBind: false,
    bindData:{
      imei:"",
      sn:"",
      car_license:"",
      car_icon:"",
      car_brand:'',
      car_model:'',
      series_id:0,
      totalMiles:5,
    }
  },
  mutations: {
    increment (state,{imei,iccid}) {
      state.nowImei = imei,
      state.nowIccid = iccid
    },
    carBrandHandle (state,{carLogo,carBrandName}) {
      state.bindData.car_brand = carBrandName;
      state.bindData.car_icon = carLogo;
    },
    carModelHandle (state,{id,carModelName}) {
      state.bindData.series_id = id
      state.bindData.car_model = carModelName;
    },
    carPlateHandle (state,plate) {
      state.bindData.car_license = plate
    },
    carRecordHandle (state,{imei,sn,totalMiles}) {
      state.bindData.imei = imei
      state.bindData.sn =sn
      state.bindData.totalMiles =totalMiles
    },
    deviceBindChange (state,isBind) {
      state.isChangeBind = isBind
    }
  },
  actions: {
    increment (context) {
      context.commit('increment')
    }
  }
})
